import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const queryCsPunish = async (params: object) => {
  return await GET({
    url: Api.queryCsPunish,
    params,
    showError: false,
    headers: {
      rpcType: 'dubbo'
    }
  })
}
export const submitAppeal = async (params: object) => {
  return await POST({
    url: Api.submitAppeal,
    data: params,
    showError: false,
    headers: {
      rpcType: 'dubbo'
    }
  })
}
